module.exports = __webpack_public_path__ + "83f234bef679dc54f1d2b09310adf856.png";